import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api/axios';
import './AdminForm.css';

const AdminForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    bookName: '',
    price: '',
    bookBox: '',
    author: '',
    linkToPost: '',
    coverImageUrl: '',
    firstAccessDate: '',
    firstAccessTimeUKINT: '',
    firstAccessTimeUSCanada: '',
    firstAccessTimeLocalRegional: '',
    earlyAccessDate: '',
    earlyAccessDateTimeUKINT: '',
    earlyAccessDateTimeUSCanada: '',
    activeSubscribersTimeLocalRegional: '',
    publicAccessDate: '',
    publicAccessTimeUKINT: '',
    publicAccessTimeUSCanada: '',
    publicAccessTimeLocalRegional: '',
    shipmentDate: '',
    openPreorderDate: '',
    openPreorderTime: '',
    preorderCloseDate: '',
    preorderCloseTime: '',
    membersOnlyDate: '',
    membersOnlyTime: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // BookBox list - same as AdminAnalyze
  const bookBoxList = [
    'AcryliPics', 'AOTA', 'Allurial', 'Aurora Crate',
    'Autumn Midnights', 'Baddies', 'Bad Women Books', 'Merch with Indies',
    'Bewitched Pages', 'Belle', 'Beyond the Pages', 'Book in a Box',
    'Bookish & Spice', 'BFDC', 'C2C', 'Coveted Cover',
    'Dainty', 'Dark & Disturbed', 'Blackout Romance', 'Motley Chronicles',
    'Dark and Nerdy', 'Dark & Quirky', 'Endless Pages', 'Eternal Embers',
    'Euphoric Lit', 'Everheart', 'Fae Crate', 'Fairyloot', 'Fated Romance',
    'Final Score', 'Foxglove', 'Fox & Wit', 'Haunted Hearts',
    'Hello Lovely', 'Hidden Secrets Bookstore', 'Illumicrate', 'Afterlight',
    'Starbright', 'Evernight', 'Mindsight', 'Lavish Library', 'La Petite Mort',
    'Lilac Library\'s', 'Lit Haven', 'LitJoy', 'Little Wicked',
    'Luna & Lore', 'Lunarya', 'Midnight Whispers', 'Roses & Thorns', 'Phoenix',
    'Moonbowbookclub', 'Moonlight', 'Mystic Box', 'Nocturnal Ink Book Co',
    'Obsidian Descension', 'OwlCrate', 'Page and Wick', 'PXC',
    'Red Flags & Roses', 'RIP', 'Renegade Romance', 'Romance Cartel',
    'Romance Era', 'Romance Reveal', 'Shades of Desire Books & Co.',
    'Sinful Obsessions', 'Smut & Sip', 'Sonny', 'Spiced',
    'Arcane Society', 'Book Cove ZA', 'Bookaholic', 'Bookish Box',
    'Bound Collector', 'Brightside Candles', 'Broken Binding', 'Butterfly Book Club',
    'Ink Pages', 'Last Chapter', 'Locked Library', 'Lovely Story Society',
    'Midnight Bookshelf', 'TPLW', 'Quill & Quiver',
    'Twisted Fiction', 'Twisted Retreat', 'Unplugged', 'Wolfsbane'
  ];

  useEffect(() => {
    const analyzedData = localStorage.getItem('analyzedEvent');
    const inputText = localStorage.getItem('inputText');
    
    if (analyzedData) {
      const data = JSON.parse(analyzedData);
      
      // Print the result from the prompt execution in browser console
      console.log('📋 Analyzed Event Data from Prompt Execution:');
      console.log('═══════════════════════════════════════════════════════════════════');
      console.log(JSON.stringify(data, null, 2));
      console.log('═══════════════════════════════════════════════════════════════════');
      
      // Helper function to extract date from ISO datetime string for date input (YYYY-MM-DD)
      const extractDateFromDateTime = (dateTimeString) => {
        if (!dateTimeString) return '';
        // If it's an ISO datetime string, extract just the date part
        if (dateTimeString.includes('T')) {
          return dateTimeString.split('T')[0];
        }
        // If it's already in YYYY-MM-DD format, return as is
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateTimeString)) {
          return dateTimeString;
        }
        // Otherwise return empty string
        return '';
      };

      // Helper function to parse human-readable date strings to YYYY-MM-DD format
      const parseHumanReadableDate = (dateString) => {
        if (!dateString || typeof dateString !== 'string') return '';
        const trimmed = dateString.trim();
        if (!trimmed || trimmed.toLowerCase() === 'n/a' || trimmed.toLowerCase() === 'not specified') return '';
        
        // If already in YYYY-MM-DD format, return as is
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
          return trimmed;
        }
        
        // Try to parse formats like "February 13th", "February 13", "Feb 13", etc.
        // This is a simple parser - for production, consider using a library like date-fns
        const monthNames = {
          'january': 0, 'jan': 0,
          'february': 1, 'feb': 1,
          'march': 2, 'mar': 2,
          'april': 3, 'apr': 3,
          'may': 4,
          'june': 5, 'jun': 5,
          'july': 6, 'jul': 6,
          'august': 7, 'aug': 7,
          'september': 8, 'sep': 8, 'sept': 8,
          'october': 9, 'oct': 9,
          'november': 10, 'nov': 10,
          'december': 11, 'dec': 11
        };
        
        // Try to match patterns like "February 13th", "February 13", "Feb 13th", etc.
        const dateMatch = trimmed.match(/(\w+)\s+(\d{1,2})(?:st|nd|rd|th)?(?:\s*,?\s*(\d{4}))?/i);
        if (dateMatch) {
          const monthName = dateMatch[1].toLowerCase();
          const day = parseInt(dateMatch[2], 10);
          const year = dateMatch[3] ? parseInt(dateMatch[3], 10) : new Date().getFullYear();
          
          if (monthNames[monthName] !== undefined && day >= 1 && day <= 31) {
            const month = monthNames[monthName];
            try {
              const date = new Date(year, month, day);
              if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
                return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
              }
            } catch (e) {
              // Invalid date
            }
          }
        }
        
        // Try to parse with Date constructor as fallback
        try {
          const parsed = new Date(trimmed);
          if (!isNaN(parsed.getTime())) {
            const year = parsed.getFullYear();
            const month = String(parsed.getMonth() + 1).padStart(2, '0');
            const day = String(parsed.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
          }
        } catch (e) {
          // Parsing failed
        }
        
        return '';
      };

      // Helper function to extract time from ISO datetime string for time input (HH:MM)
      const extractTimeFromDateTime = (dateTimeString) => {
        if (!dateTimeString) return '';
        // If it's an ISO datetime string, extract the time part
        if (dateTimeString.includes('T')) {
          const timePart = dateTimeString.split('T')[1];
          if (timePart) {
            // Extract HH:MM from HH:MM:SS or HH:MM:SS.sssZ format
            const timeMatch = timePart.match(/^(\d{2}):(\d{2})/);
            if (timeMatch) {
              return `${timeMatch[1]}:${timeMatch[2]}`;
            }
          }
        }
        return '';
      };

      // Helper function to convert time string to HH:MM format for time inputs
      const convertToTimeFormat = (timeString) => {
        // Handle null, undefined, or empty values
        if (!timeString) return '';
        // Convert to string if it's a number or other type
        if (typeof timeString !== 'string') {
          timeString = String(timeString);
        }
        const trimmed = timeString.trim();
        if (!trimmed) return '';
        
        // Remove common timezone indicators and extra text (EST, GMT, etc.)
        // But preserve AM/PM which might come before or after timezone
        let cleanTime = trimmed.replace(/\s*(est|gmt|utc|pst|pdt|edt|cdt|mdt|mst)\s*/gi, '').trim();
        
        // FIRST: Check for AM/PM format (must check before HH:MM to avoid missing AM/PM)
        // Try to parse formats like "1:00 PM", "9:30am", "2pm", "9am EST", "1:00PM", "1:00 P.M.", etc.
        // More robust regex that handles spaces, periods, and various formats
        // Pattern 1: With colon and minutes: "1:00 PM", "1:00PM", "1:00 P.M."
        const ampmMatchWithMinutes = cleanTime.match(/(\d{1,2})\s*:\s*(\d{1,2})\s*(am|pm|a\.m\.|p\.m\.)/i);
        // Pattern 2: Without minutes: "1 PM", "1PM", "1 P.M."
        const ampmMatchWithoutMinutes = cleanTime.match(/(\d{1,2})\s+(am|pm|a\.m\.|p\.m\.)/i) || 
                                        cleanTime.match(/(\d{1,2})(am|pm|a\.m\.|p\.m\.)/i);
        
        if (ampmMatchWithMinutes) {
          let hours = parseInt(ampmMatchWithMinutes[1], 10);
          const minutes = parseInt(ampmMatchWithMinutes[2], 10);
          // Normalize AM/PM (handle "a.m.", "p.m.", "AM", "PM", etc.)
          const ampm = ampmMatchWithMinutes[3].toLowerCase().replace(/\./g, '');
          
          // Validate hours and minutes
          if (hours < 1 || hours > 12) return '';
          if (minutes < 0 || minutes > 59) return '';
          
          // Convert to 24-hour format
          if (ampm === 'pm' && hours !== 12) {
            hours += 12;
          } else if (ampm === 'am' && hours === 12) {
            hours = 0;
          }
          
          if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
          }
        } else if (ampmMatchWithoutMinutes) {
          let hours = parseInt(ampmMatchWithoutMinutes[1], 10);
          const minutes = 0;
          // Normalize AM/PM (handle "a.m.", "p.m.", "AM", "PM", etc.)
          const ampm = ampmMatchWithoutMinutes[2].toLowerCase().replace(/\./g, '');
          
          // Validate hours
          if (hours < 1 || hours > 12) return '';
          
          // Convert to 24-hour format
          if (ampm === 'pm' && hours !== 12) {
            hours += 12;
          } else if (ampm === 'am' && hours === 12) {
            hours = 0;
          }
          
          if (hours >= 0 && hours <= 23) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
          }
        }
        
        // SECOND: If already in HH:MM or HH:MM:SS format (without AM/PM), extract and pad as needed
        // Handle formats like "9:5", "9:05", "09:5", "09:05", "9:5:30", etc.
        const timeMatch = cleanTime.match(/^(\d{1,2}):(\d{1,2})(?::\d{1,2})?$/);
        if (timeMatch) {
          const hours = parseInt(timeMatch[1], 10);
          const minutes = parseInt(timeMatch[2], 10);
          if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
          }
        }
        
        // Handle just hours (e.g., "9", "09")
        const justHoursMatch = cleanTime.match(/^(\d{1,2})$/);
        if (justHoursMatch) {
          const hours = parseInt(justHoursMatch[1], 10);
          if (hours >= 0 && hours <= 23) {
            return `${hours.toString().padStart(2, '0')}:00`;
          }
        }
        
        // If we still have a valid-looking number, try to parse it as hours
        const numberMatch = cleanTime.match(/^(\d{1,2})/);
        if (numberMatch) {
          const hours = parseInt(numberMatch[1], 10);
          if (hours >= 0 && hours <= 23) {
            return `${hours.toString().padStart(2, '0')}:00`;
          }
        }
        
        // Return empty string if we can't parse it
        return '';
      };

      // Helper function to parse author from inputText
      const parseAuthorFromInputText = (inputText) => {
        if (!inputText || typeof inputText !== 'string') return '';
        
        const text = inputText.trim();
        if (!text) return '';
        
        // Try to find author after "author:" or "Author:" pattern
        const authorPattern = /(?:^|\n)\s*(?:author|Author):\s*(.+?)(?=\n\s*(?:book|price|date|time|preorder|members|early|public|shipment|description|$))/is;
        const authorMatch = text.match(authorPattern);
        if (authorMatch && authorMatch[1]) {
          return authorMatch[1].trim();
        }
        
        // Try to find author in markdown table format
        const markdownTablePattern = /(?:^|\n)\s*\|?\s*Author\s*\|?\s*(.+?)(?=\n|$)/i;
        const markdownMatch = text.match(markdownTablePattern);
        if (markdownMatch && markdownMatch[1]) {
          const value = markdownMatch[1].split('|')[0].trim();
          if (value && !value.includes('---')) {
            return value;
          }
        }
        
        return '';
      };

      // Parse author from analyzed data or inputText
      let author = data.author || '';
      if (!author && inputText) {
        author = parseAuthorFromInputText(inputText);
        if (author) {
          console.log('📝 Author parsed from inputText:', author);
        }
      }

      // Helper function to parse publicAccessTime for UK/INT and US/Canada
      const parsePublicAccessTime = (publicAccessTime) => {
        if (!publicAccessTime || typeof publicAccessTime !== 'string') {
          return { ukInt: '', usCanada: '' };
        }
        
        const timeStr = publicAccessTime.trim();
        if (!timeStr) {
          return { ukInt: '', usCanada: '' };
        }
        
        // Clean the string - remove common prefixes and extra text
        let cleanStr = timeStr.replace(/\s*(for|at|@)\s*/gi, ' ').trim();
        
        // Pattern 1: Look for explicit UK/INT and US/Canada markers
        // Examples: "8am UK/INT and 11am US/Canada", "8am for UK/INT, 11am for US/Canada"
        const ukIntPattern = /(\d{1,2}(?::\d{1,2})?\s*(?:am|pm)?)\s*(?:for\s*)?(?:uk\/int|uk-int|uk\s*int)/i;
        const usCanadaPattern = /(\d{1,2}(?::\d{1,2})?\s*(?:am|pm)?)\s*(?:for\s*)?(?:us\/canada|us-canada|us\s*canada|us|canada)/i;
        
        const ukIntMatch = cleanStr.match(ukIntPattern);
        const usCanadaMatch = cleanStr.match(usCanadaPattern);
        
        if (ukIntMatch || usCanadaMatch) {
          return {
            ukInt: ukIntMatch ? convertToTimeFormat(ukIntMatch[1]) || '' : '',
            usCanada: usCanadaMatch ? convertToTimeFormat(usCanadaMatch[1]) || '' : ''
          };
        }
        
        // Pattern 2: Handle multiple times separated by "and", ",", or "&"
        // Common formats: "8am and 11am", "8am, 11am", "8am & 11am", "8am, 11am EST"
        const timeSeparators = /\s+(and|&|,|\/)\s+/i;
        const parts = cleanStr.split(timeSeparators);
        const times = parts.filter(part => {
          const trimmed = part.trim();
          // Filter out separators and empty strings
          return trimmed && !/^(and|&|,|\/)$/i.test(trimmed);
        }).map(part => part.trim()).filter(part => part);
        
        if (times.length >= 2) {
          // If there are two times, try to determine which is which
          const firstTime = times[0];
          const secondTime = times[1];
          
          // Check if the original string or times contain location hints
          const lowerTimeStr = cleanStr.toLowerCase();
          const firstTimeLower = firstTime.toLowerCase();
          const secondTimeLower = secondTime.toLowerCase();
          
          let ukIntTime = '';
          let usCanadaTime = '';
          
          // Check for explicit location markers in the strings
          if (lowerTimeStr.includes('uk') || lowerTimeStr.includes('int') || 
              firstTimeLower.includes('uk') || firstTimeLower.includes('int')) {
            // First time is for UK/INT, second for US/Canada
            ukIntTime = convertToTimeFormat(firstTime) || '';
            usCanadaTime = convertToTimeFormat(secondTime) || '';
          } else if (lowerTimeStr.includes('us') || lowerTimeStr.includes('canada') ||
                     secondTimeLower.includes('us') || secondTimeLower.includes('canada')) {
            // First time might be UK/INT, second is US/Canada
            ukIntTime = convertToTimeFormat(firstTime) || '';
            usCanadaTime = convertToTimeFormat(secondTime) || '';
          } else {
            // Default: first time is UK/INT, second is US/Canada
            ukIntTime = convertToTimeFormat(firstTime) || '';
            usCanadaTime = convertToTimeFormat(secondTime) || '';
          }
          
          return {
            ukInt: ukIntTime,
            usCanada: usCanadaTime
          };
        } else if (times.length === 1) {
          // If there's only one time, check if we can determine location from context
          const singleTime = times[0];
          
          // Check if the string mentions which region this time is for
          if (timeStr.toLowerCase().match(/(uk|int|international|british|europe)/i)) {
            return {
              ukInt: convertToTimeFormat(singleTime) || '',
              usCanada: ''
            };
          } else if (timeStr.toLowerCase().match(/(us|canada|north\s*america)/i)) {
            return {
              ukInt: '',
              usCanada: convertToTimeFormat(singleTime) || ''
            };
          } else {
            // Default: assign to UK/INT (can be manually adjusted)
            return {
              ukInt: convertToTimeFormat(singleTime) || '',
              usCanada: ''
            };
          }
        }
        
        // Fallback: try to parse as single time
        return {
          ukInt: convertToTimeFormat(timeStr) || '',
          usCanada: ''
        };
      };

      // Parse publicAccessTime if it exists and specific fields don't
      let publicAccessTimeUKINT = convertToTimeFormat(data.publicAccessTimeUKINT) || '';
      let publicAccessTimeUSCanada = convertToTimeFormat(data.publicAccessTimeUSCanada) || '';
      
      // If publicAccessTime exists and specific fields are missing, parse it
      if (data.publicAccessTime && (!publicAccessTimeUKINT || !publicAccessTimeUSCanada)) {
        const parsedTimes = parsePublicAccessTime(data.publicAccessTime);
        if (!publicAccessTimeUKINT && parsedTimes.ukInt) {
          publicAccessTimeUKINT = parsedTimes.ukInt;
          console.log('📝 Public Access Time UK/INT parsed from publicAccessTime:', publicAccessTimeUKINT);
        }
        if (!publicAccessTimeUSCanada && parsedTimes.usCanada) {
          publicAccessTimeUSCanada = parsedTimes.usCanada;
          console.log('📝 Public Access Time US/Canada parsed from publicAccessTime:', publicAccessTimeUSCanada);
        }
      }

      // Ensure price always has " + shipping" appended
      let price = data.price || '';
      if (price.trim() && !price.trim().endsWith(' + shipping')) {
        price = price.trim() + ' + shipping';
      }

      setFormData({
        bookName: data.bookName || '',
        price: price,
        bookBox: data.bookBox || '',
        author: author,
        linkToPost: '',
        // Prefer human-readable API dates: *DateTime* ISO is UTC, so the YYYY-MM-DD
        // slice can be the wrong calendar day vs Eastern wall time (e.g. 8pm ET → next UTC day).
        firstAccessDate:
          parseHumanReadableDate(data.firstAccessDate) ||
          parseHumanReadableDate(data.firstAccessDateUKINT) ||
          parseHumanReadableDate(data.firstAccessDateUSCanada) ||
          extractDateFromDateTime(data.firstAccessDateTime) || '',
        firstAccessTimeUKINT: convertToTimeFormat(data.firstAccessTimeUKINT) || '',
        firstAccessTimeUSCanada: convertToTimeFormat(data.firstAccessTimeUSCanada) || '',
        firstAccessTimeLocalRegional: convertToTimeFormat(data.firstAccessTimeLocalRegional) || '',
        earlyAccessDate:
          parseHumanReadableDate(data.earlyAccessDate) ||
          parseHumanReadableDate(data.earlyAccessDateUKINT) ||
          parseHumanReadableDate(data.earlyAccessDateUSCanada) ||
          extractDateFromDateTime(data.earlyAccessDateTime) || '',
        earlyAccessDateTimeUKINT: convertToTimeFormat(data.earlyAccessDateTimeUKINT) || '',
        earlyAccessDateTimeUSCanada: convertToTimeFormat(data.earlyAccessDateTimeUSCanada) || '',
        activeSubscribersTimeLocalRegional: convertToTimeFormat(data.activeSubscribersTimeLocalRegional) || '',
        publicAccessDate:
          parseHumanReadableDate(data.publicAccessDate) ||
          parseHumanReadableDate(data.publicAccessDateUKINT) ||
          parseHumanReadableDate(data.publicAccessDateUSCanada) ||
          extractDateFromDateTime(data.publicAccessDateTime) || '',
        publicAccessTimeUKINT: publicAccessTimeUKINT,
        publicAccessTimeUSCanada: publicAccessTimeUSCanada,
        publicAccessTimeLocalRegional: convertToTimeFormat(data.publicAccessTimeLocalRegional) || '',
        shipmentDate: data.shipmentDate || '',
        openPreorderDate:
          parseHumanReadableDate(data.openPreorderDate) ||
          extractDateFromDateTime(data.openPreorderDateTime) || '',
        openPreorderTime: extractTimeFromDateTime(data.openPreorderDateTime) || convertToTimeFormat(data.openPreorderTime) || '',
        preorderCloseDate:
          parseHumanReadableDate(data.preorderCloseDate) ||
          extractDateFromDateTime(data.preorderCloseDateTime) || '',
        preorderCloseTime: extractTimeFromDateTime(data.preorderCloseDateTime) || convertToTimeFormat(data.preorderCloseTime) || '',
        membersOnlyDate:
          parseHumanReadableDate(data.membersOnlyDate) ||
          extractDateFromDateTime(data.membersOnlyDateTime) || '',
        membersOnlyTime: extractTimeFromDateTime(data.membersOnlyDateTime) || convertToTimeFormat(data.membersOnlyTime) || '',
      });
      localStorage.removeItem('analyzedEvent');
      localStorage.removeItem('inputText');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    
    // Always append " + shipping" to price field if it doesn't already have it
    if (name === 'price' && value.trim() && !value.trim().endsWith(' + shipping')) {
      processedValue = value.trim() + ' + shipping';
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: processedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prevent duplicate submissions
    if (loading) {
      console.warn('[AdminForm] Submission already in progress, ignoring duplicate submit');
      return;
    }
    
    setLoading(true);
    setError('');

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        let value = formData[key];
        // Ensure price always has " + shipping" before submitting
        if (key === 'price' && value.trim() && !value.trim().endsWith(' + shipping')) {
          value = value.trim() + ' + shipping';
        }
        formDataToSend.append(key, value);
      });

      console.log('\n[AdminForm] Submitting event data:');
      console.log('  Book Name:', formData.bookName);
      console.log('  Price:', formData.price);
      console.log('  Book Box:', formData.bookBox);
      console.log('  Author:', formData.author);
      console.log('  Link to Post:', formData.linkToPost);
      console.log('  First Access Date:', formData.firstAccessDate);
      console.log('  First Access Time UK/INT:', formData.firstAccessTimeUKINT);
      console.log('  First Access Time US/Canada:', formData.firstAccessTimeUSCanada);
      console.log('  First Access Time Local/Regional:', formData.firstAccessTimeLocalRegional);
      console.log('  Early Access Date:', formData.earlyAccessDate);
      console.log('  Active Subscribers Time UK/INT:', formData.earlyAccessDateTimeUKINT);
      console.log('  Active Subscribers Time US/Canada:', formData.earlyAccessDateTimeUSCanada);
      console.log('  Active Subscribers Time Local/Regional:', formData.activeSubscribersTimeLocalRegional);
      console.log('  General Access Date:', formData.publicAccessDate);
      console.log('  General Access Time UK/INT:', formData.publicAccessTimeUKINT);
      console.log('  General Access Time US/Canada:', formData.publicAccessTimeUSCanada);
      console.log('  General Access Time Local/Regional:', formData.publicAccessTimeLocalRegional);
      console.log('  Shipment Date:', formData.shipmentDate);
      console.log('  Open Preorder Date:', formData.openPreorderDate);
      console.log('  Open Preorder Time:', formData.openPreorderTime);
      console.log('  Preorder Close Date:', formData.preorderCloseDate);
      console.log('  Preorder Close Time:', formData.preorderCloseTime);
      console.log('  Members Only Date:', formData.membersOnlyDate);
      console.log('  Members Only Time:', formData.membersOnlyTime);
      console.log('  FormData entries:');
      for (let [key, value] of formDataToSend.entries()) {
        console.log(`    ${key}:`, value);
      }

      const response = await api.post('/events', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('[AdminForm] ✅ Event saved successfully!');
      console.log('  Response:', response.data);
      const eventsCreated = Array.isArray(response.data) ? response.data.length : 0;
      console.log('  Events created:', eventsCreated);
      
      if (eventsCreated === 0) {
        console.warn('[AdminForm] ⚠️ WARNING: No events were created. Please check that at least one time field has a value.');
        setError('Warning: No events were created. Please ensure at least one time field has a value.');
      } else {
        console.log(`[AdminForm] ✅ ${eventsCreated} event(s) created successfully`);
      }

      navigate('/admin/events');
    } catch (err) {
      console.error('[AdminForm] ❌ Error saving event:');
      console.error('  Error object:', err);
      console.error('  Response status:', err.response?.status);
      console.error('  Response data:', err.response?.data);
      console.error('  Error message:', err.message);
      setError(err.response?.data?.message || err.message || 'Error saving event');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/admin');
  };

  return (
    <div className="admin-form">
      <nav className="admin-nav">
        <div className="nav-container">
          <button 
            className={`nav-button ${location.pathname === '/admin/analyze' ? 'active' : ''}`}
            onClick={() => navigate('/admin/analyze')}
          >
            Analyze
          </button>
          <button 
            className={`nav-button ${location.pathname === '/admin/form' ? 'active' : ''}`}
            onClick={() => navigate('/admin/form')}
          >
            Form
          </button>
        </div>
      </nav>
      <h2>Event Form</h2>
      <form onSubmit={handleSubmit} className="event-form">
        <div className="form-row">
          <div className="form-group">
            <label>Book Name *</label>
            <input
              type="text"
              name="bookName"
              value={formData.bookName}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Book Price</label>
            <input
              type="text"
              name="price"
              value={formData.price}
              onChange={handleChange}
              placeholder="e.g., £24 or $32 or £24 GBP / $32 USD"
            />
          </div>
          <div className="form-group">
            <label>Book Box</label>
            <select
              name="bookBox"
              value={formData.bookBox}
              onChange={handleChange}
            >
              <option value="">-- Select a Book Box --</option>
              {bookBoxList.map((boxName, index) => (
                <option key={index} value={boxName}>
                  {boxName}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Estimated to ship</label>
            <input
              type="text"
              name="shipmentDate"
              value={formData.shipmentDate}
              onChange={handleChange}
              placeholder="e.g., May 2026 or May/June 2026"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Author</label>
            <input
              type="text"
              name="author"
              value={formData.author}
              onChange={handleChange}
              placeholder="Enter author name"
            />
          </div>
          <div className="form-group">
            <label>Post LINK</label>
            <input
              type="url"
              name="linkToPost"
              value={formData.linkToPost}
              onChange={handleChange}
              placeholder="Enter link to the post"
            />
          </div>
          <div className="form-group">
            <label>Cover Link:</label>
            <input
              type="url"
              name="coverImageUrl"
              value={formData.coverImageUrl}
              onChange={handleChange}
              placeholder="Paste image URL for book cover"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>First Access Date</label>
            <input
              type="date"
              name="firstAccessDate"
              value={formData.firstAccessDate}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>First Access Time (EST) - UK/INT</label>
            <input
              type="time"
              name="firstAccessTimeUKINT"
              value={formData.firstAccessTimeUKINT}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>First Access Time (EST) - US/Canada</label>
            <input
              type="time"
              name="firstAccessTimeUSCanada"
              value={formData.firstAccessTimeUSCanada}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>First Access Time (EST) — Local / regional (single time)</label>
            <input
              type="time"
              name="firstAccessTimeLocalRegional"
              value={formData.firstAccessTimeLocalRegional}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Early Access Date</label>
            <input
              type="date"
              name="earlyAccessDate"
              value={formData.earlyAccessDate}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Early Access Time (EST) - UK/INT</label>
            <input
              type="time"
              name="earlyAccessDateTimeUKINT"
              value={formData.earlyAccessDateTimeUKINT}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Early Access Time (EST) - US/Canada</label>
            <input
              type="time"
              name="earlyAccessDateTimeUSCanada"
              value={formData.earlyAccessDateTimeUSCanada}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Early Access Time (EST) — Local / regional (single time)</label>
            <input
              type="time"
              name="activeSubscribersTimeLocalRegional"
              value={formData.activeSubscribersTimeLocalRegional}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>General Access Date (EST)</label>
            <input
              type="date"
              name="publicAccessDate"
              value={formData.publicAccessDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>General Access Time (EST) - UK/INT</label>
            <input
              type="time"
              name="publicAccessTimeUKINT"
              value={formData.publicAccessTimeUKINT}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>General Access Time (EST) - US/Canada</label>
            <input
              type="time"
              name="publicAccessTimeUSCanada"
              value={formData.publicAccessTimeUSCanada}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>General Access Time (EST) — Local / regional (single time)</label>
            <input
              type="time"
              name="publicAccessTimeLocalRegional"
              value={formData.publicAccessTimeLocalRegional}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Open Preorder Date</label>
            <input
              type="date"
              name="openPreorderDate"
              value={formData.openPreorderDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Open Preorder Time</label>
            <input
              type="time"
              name="openPreorderTime"
              value={formData.openPreorderTime}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Preorder Close Date</label>
            <input
              type="date"
              name="preorderCloseDate"
              value={formData.preorderCloseDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Preorder Close Time</label>
            <input
              type="time"
              name="preorderCloseTime"
              value={formData.preorderCloseTime}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Members Only Date</label>
            <input
              type="date"
              name="membersOnlyDate"
              value={formData.membersOnlyDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Members Only Time</label>
            <input
              type="time"
              name="membersOnlyTime"
              value={formData.membersOnlyTime}
              onChange={handleChange}
            />
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="form-actions">
          <button type="button" onClick={handleCancel} className="cancel-btn">
            Cancel
          </button>
          <button type="submit" disabled={loading} className="save-btn">
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminForm;

